import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthConfigService } from '../../Configuration/auth-config.service';
import { BaseEntityModel } from '../../Data/Models/Common/base-entity-model';
import { UserLicenseDetailsModel } from '../../Data/Models/Users/user-license-details-model';
import { UsersApiService } from './users-api.service';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LicenceDataShareService {
  currentUser: any;
    central_User_ID: any;
    productID: any;
    TableRecordCnt: any;
    numberOfUsers: any;
    planId: any;
    pricingID: any;

  constructor(private userAPIService: UsersApiService, private authconfigService: AuthConfigService) { }

  Upgrade(Type: any) {
    debugger
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.currentUser = parsedUser.userID;

    }
    this.userAPIService.getUserLicenseDetails(this.currentUser).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      debugger
      if (data.status == 0) {
        if (data.entity != null && data.entity.length > 0) {
          this.central_User_ID = data.entity[0].central_User_ID
          this.TableRecordCnt = data.entity[0].totalNoofCharitiescreated
          this.planId = data.entity[0].planId;
          this.pricingID = data.entity[0].pricingId;
          this.productID = data.entity[0].productID
          this.numberOfUsers = data.entity[0].number_Of_Users >= 99999 ? 'Unlimited' : data.entity[0].number_Of_Users;
         
        }
      }
    });
  
 

    this.userAPIService.getUserLicenseDetails(this.currentUser).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      debugger
      if (data.entity[0].userStatus == true) {
        var centralUserID = (this.central_User_ID).toString();

        var subscriptionURL = this.authconfigService.getSubscriptionAPIUrl();
        var prodId = (this.productID).toString();
        prodId = prodId.split('+').join('vkanslab');

        var encryptedDataProdID = CryptoJS.AES.encrypt(prodId, "My Secret Passphrase");
        var ProductID = encryptedDataProdID.toString();
        ProductID = ProductID.split('+').join('vkanslab');

        var encryptedData1 = CryptoJS.AES.encrypt(centralUserID, "My Secret Passphrase");
        var centralUserId = encryptedData1.toString();
        centralUserId = centralUserId.split('+').join('vkanslab');

        var name = ''
        if (Type == 'Upgrade') {
          var encryptedData2 = CryptoJS.AES.encrypt("Upgrade", "My Secret Passphrase");
          name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        } else if (Type == 'Renew') {
          var encryptedData2 = CryptoJS.AES.encrypt("Renew", "My Secret Passphrase");
          name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        }



        var encryptedData3 = CryptoJS.AES.encrypt(this.TableRecordCnt + "", "My Secret Passphrase");
        var numberOfCharitiesCreated = encryptedData3.toString();
        numberOfCharitiesCreated = numberOfCharitiesCreated.split('+').join('vkanslab');


        var encryptedData4 = CryptoJS.AES.encrypt("Annually", "My Secret Passphrase");
        var subType = encryptedData4.toString();
        subType = subType.split('+').join('vkanslab');


        var numOfUsers = this.numberOfUsers + "";
        var encryptedData5 = CryptoJS.AES.encrypt(numOfUsers, "My Secret Passphrase");
        var numberOfUsers = encryptedData5.toString();
        numberOfUsers = numberOfUsers.split('+').join('vkanslab');

        var StatusFrom = ''
        var PlanId = ''
        var PricingID = ''
        //upgrade from users
        if (Type == 'Upgrade' || Type == 'Renew') {
          var encryptedData6 = CryptoJS.AES.encrypt("FromCompanies", "My Secret Passphrase");
          StatusFrom = encryptedData6.toString();
          StatusFrom = StatusFrom.split('+').join('vkanslab');
          var encryptedDataPlanId = CryptoJS.AES.encrypt(this.planId + "", "My Secret Passphrase");
          PlanId = encryptedDataPlanId.toString();
          PlanId = PlanId.split('+').join('vkanslab');
          var encryptedDataPricingID = CryptoJS.AES.encrypt(this.pricingID + "", "My Secret Passphrase");
          PricingID = encryptedDataPricingID.toString();
          PricingID = PricingID.split('+').join('vkanslab');
        }
        debugger;
        var URL = "";
        //subscriptionURL ='https://subscriptions.dev.acuitysoft.com'   //for testing
        if (Type == 'Renew' || Type == 'Upgrade') {
          URL = subscriptionURL + "/payment/plandetails/CustomerPlans?ProductName=" + ProductID + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfCharitiesCreated + "&subType=" + subType + "&RegUsers=" + numberOfUsers + "&StatusFrom=" + StatusFrom + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        else {
          URL = subscriptionURL + "/payment/plandetails/CustomerPlans?ProductName=" + ProductID + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfCharitiesCreated + "&subType=" + subType + "&RegUsers=" + numberOfUsers + "&StatusFrom=" + StatusFrom + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        window.open(URL, '_self');
      } else {
        Swal.fire('', "This software license is deactivated .please contact Andica Sales.");
        return;
      }
    });
  }
}
